import { render } from "./data-empty.vue?vue&type=template&id=30dde21f&scoped=true&lang=true"
import script from "./data-empty.vue?vue&type=script&lang=js"
export * from "./data-empty.vue?vue&type=script&lang=js"

import "./data-empty.vue?vue&type=style&index=0&id=30dde21f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dde21f"]])

export default __exports__